module.exports = __webpack_public_path__ + "img/icon_llama.15f29dec.svg";